var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.01101 10.8269L2.659 7.96452",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72943 16.9711C5.57305 18.6175 6.91536 20.0399 8.71295 20.9167C13.126 23.0691 18.448 21.2366 20.6004 16.8235C22.7528 12.4104 20.9203 7.08848 16.5072 4.93607C12.0941 2.78367 6.77218 4.61616 4.61978 9.02924C4.32169 9.64042 4.1133 10.2731 3.96756 10.9141",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02148 10.8789L6.915 9.50866",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9342 16.9069L11.3481 14.8128C11.2423 14.7507 11.1546 14.6628 11.0937 14.5577C11.0327 14.4527 11.0004 14.334 11 14.2132V9.69832C11 9.51311 11.0752 9.33549 11.209 9.20453C11.3427 9.07357 11.5242 9 11.7134 9C11.9026 9 12.0841 9.07357 12.2179 9.20453C12.3516 9.33549 12.4268 9.51311 12.4268 9.69832V13.8156L15.6609 15.7057C15.8205 15.8022 15.9349 15.9562 15.9795 16.1345C16.0241 16.3128 15.9953 16.5011 15.8992 16.6588C15.8032 16.8165 15.6477 16.9309 15.4662 16.9773C15.2848 17.0237 15.092 16.9984 14.9294 16.9069H14.9342Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentActivity);
export default __webpack_public_path__ + "static/media/recentActivity.4f179417fce5bb2a57529582a65d43ce.svg";
export { ForwardRef as ReactComponent };